/**
 * Sectors configuration
 *
 * This file is auto-generated by the balance importer.
 * Do not edit manually - changes will be overwritten.
 *
 * Generated at: 2025-09-25T12:43:18.989Z
 */

import { ConfigType } from './ConfigType';

export interface SectorConfig {
  Galaxy: string;
  idx: number;
  floor: string;
  sector_name: string;
  hp_mult: number;
  armor_add: number;
  res_laser: number;
  res_bomb: number;
  density: number;
  asteroid_mix_id: string;
  base_loot_pool_id: string;
  configType: ConfigType.SECTORS;
}

export const sectorsData: SectorConfig[] = [
  {
    Galaxy: 'G1',
    idx: 1,
    floor: 'S1',
    sector_name: 'Aurora Belt',
    hp_mult: 1,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 2,
    floor: 'S2',
    sector_name: 'Aurora Belt',
    hp_mult: 1.07,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 3,
    floor: 'S3',
    sector_name: 'Aurora Belt',
    hp_mult: 1.13,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 4,
    floor: 'S4',
    sector_name: 'Aurora Belt',
    hp_mult: 1.21,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 5,
    floor: 'S5',
    sector_name: 'Aurora Belt',
    hp_mult: 1.29,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 6,
    floor: 'S6',
    sector_name: 'Aurora Belt',
    hp_mult: 1.37,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 7,
    floor: 'S7',
    sector_name: 'Aurora Belt',
    hp_mult: 1.46,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 8,
    floor: 'S8',
    sector_name: 'Aurora Belt',
    hp_mult: 1.55,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 9,
    floor: 'S9',
    sector_name: 'Aurora Belt',
    hp_mult: 1.65,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 10,
    floor: 'S10',
    sector_name: 'Aurora Belt',
    hp_mult: 1.76,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 11,
    floor: 'S11',
    sector_name: 'Aurora Belt',
    hp_mult: 1.88,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 12,
    floor: 'S12',
    sector_name: 'Aurora Belt',
    hp_mult: 2,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 13,
    floor: 'S13',
    sector_name: 'Aurora Belt',
    hp_mult: 2.13,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 14,
    floor: 'S14',
    sector_name: 'Aurora Belt',
    hp_mult: 2.27,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 15,
    floor: 'S15',
    sector_name: 'Aurora Belt',
    hp_mult: 2.41,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 16,
    floor: 'S16',
    sector_name: 'Aurora Belt',
    hp_mult: 2.57,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 17,
    floor: 'S17',
    sector_name: 'Aurora Belt',
    hp_mult: 2.74,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 18,
    floor: 'S18',
    sector_name: 'Aurora Belt',
    hp_mult: 2.92,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 19,
    floor: 'S19',
    sector_name: 'Aurora Belt',
    hp_mult: 3.11,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 20,
    floor: 'S20',
    sector_name: 'Aurora Belt',
    hp_mult: 3.31,
    armor_add: 0,
    res_laser: 0,
    res_bomb: 0,
    density: 1,
    asteroid_mix_id: 'MIX_AURORA',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 21,
    floor: 'S21',
    sector_name: 'Flux Rift',
    hp_mult: 3.52,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 22,
    floor: 'S22',
    sector_name: 'Flux Rift',
    hp_mult: 3.75,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 23,
    floor: 'S23',
    sector_name: 'Flux Rift',
    hp_mult: 4,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 24,
    floor: 'S24',
    sector_name: 'Flux Rift',
    hp_mult: 4.26,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 25,
    floor: 'S25',
    sector_name: 'Flux Rift',
    hp_mult: 4.53,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 26,
    floor: 'S26',
    sector_name: 'Flux Rift',
    hp_mult: 4.83,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 27,
    floor: 'S27',
    sector_name: 'Flux Rift',
    hp_mult: 5.14,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 28,
    floor: 'S28',
    sector_name: 'Flux Rift',
    hp_mult: 5.48,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 29,
    floor: 'S29',
    sector_name: 'Flux Rift',
    hp_mult: 5.83,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 30,
    floor: 'S30',
    sector_name: 'Flux Rift',
    hp_mult: 6.21,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 31,
    floor: 'S31',
    sector_name: 'Flux Rift',
    hp_mult: 6.61,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 32,
    floor: 'S32',
    sector_name: 'Flux Rift',
    hp_mult: 7.04,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 33,
    floor: 'S33',
    sector_name: 'Flux Rift',
    hp_mult: 7.5,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 34,
    floor: 'S34',
    sector_name: 'Flux Rift',
    hp_mult: 7.99,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 35,
    floor: 'S35',
    sector_name: 'Flux Rift',
    hp_mult: 8.51,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 36,
    floor: 'S36',
    sector_name: 'Flux Rift',
    hp_mult: 9.06,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 37,
    floor: 'S37',
    sector_name: 'Flux Rift',
    hp_mult: 9.65,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 38,
    floor: 'S38',
    sector_name: 'Flux Rift',
    hp_mult: 10.28,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 39,
    floor: 'S39',
    sector_name: 'Flux Rift',
    hp_mult: 10.95,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 40,
    floor: 'S40',
    sector_name: 'Flux Rift',
    hp_mult: 11.66,
    armor_add: 6,
    res_laser: 0.05,
    res_bomb: 0,
    density: 1.1,
    asteroid_mix_id: 'MIX_FLUX',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 41,
    floor: 'S41',
    sector_name: 'Lumen Forge',
    hp_mult: 12.42,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 42,
    floor: 'S42',
    sector_name: 'Lumen Forge',
    hp_mult: 13.22,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 43,
    floor: 'S43',
    sector_name: 'Lumen Forge',
    hp_mult: 14.08,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 44,
    floor: 'S44',
    sector_name: 'Lumen Forge',
    hp_mult: 15,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 45,
    floor: 'S45',
    sector_name: 'Lumen Forge',
    hp_mult: 15.97,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 46,
    floor: 'S46',
    sector_name: 'Lumen Forge',
    hp_mult: 17.01,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 47,
    floor: 'S47',
    sector_name: 'Lumen Forge',
    hp_mult: 18.12,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 48,
    floor: 'S48',
    sector_name: 'Lumen Forge',
    hp_mult: 19.29,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 49,
    floor: 'S49',
    sector_name: 'Lumen Forge',
    hp_mult: 20.55,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 50,
    floor: 'S50',
    sector_name: 'Lumen Forge',
    hp_mult: 21.88,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 51,
    floor: 'S51',
    sector_name: 'Lumen Forge',
    hp_mult: 23.31,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 52,
    floor: 'S52',
    sector_name: 'Lumen Forge',
    hp_mult: 24.82,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 53,
    floor: 'S53',
    sector_name: 'Lumen Forge',
    hp_mult: 26.44,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 54,
    floor: 'S54',
    sector_name: 'Lumen Forge',
    hp_mult: 28.15,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 55,
    floor: 'S55',
    sector_name: 'Lumen Forge',
    hp_mult: 29.98,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 56,
    floor: 'S56',
    sector_name: 'Lumen Forge',
    hp_mult: 31.93,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 57,
    floor: 'S57',
    sector_name: 'Lumen Forge',
    hp_mult: 34.01,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 58,
    floor: 'S58',
    sector_name: 'Lumen Forge',
    hp_mult: 36.22,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 59,
    floor: 'S59',
    sector_name: 'Lumen Forge',
    hp_mult: 38.57,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
  {
    Galaxy: 'G1',
    idx: 60,
    floor: 'S60',
    sector_name: 'Lumen Forge',
    hp_mult: 41.08,
    armor_add: 12,
    res_laser: 0.1,
    res_bomb: 0.05,
    density: 0.9,
    asteroid_mix_id: 'MIX_LUMEN',
    base_loot_pool_id: 'LP_COMMON',
    configType: ConfigType.SECTORS,
  },
];

/**
 * Get all SectorConfig entries
 */
export function getAllSectors(): SectorConfig[] {
  return sectorsData;
}
